(function () {
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = 'video.product-card__video';
  const tracked = new WeakSet();

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.muted = true;
          const playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  function register(video) {
    if (!video || tracked.has(video)) return;
    tracked.add(video);
    video.muted = true;
    intersectionObserver.observe(video);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SELECTOR)) register(root);
    root.querySelectorAll(SELECTOR).forEach(register);
  }

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  function init() {
    scan(document.body);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
